import { forwardRef, useCallback, useRef } from 'react';
import BaseWebUniversal, { BaseWebUniversalProps } from '../../utilsTsx/components/system/BaseWebUniversal'
import systematic from '../../config/systematic';

/** 服务id类型 */
export declare type ServiceIdType = 'bm' | 'pay' | 'business' | 'mf';

/**
  * 根据服务ID获取对应的基础服务地址
  * @param serviceId 服务标识
  * @returns 服务基地址
  */
export const getService = (serviceId?: ServiceIdType) => {
    let defaultService = systematic.bmService;
    if (serviceId) {
        switch (serviceId) {
            case 'pay':
                defaultService = systematic.payService;
                break;
            case 'business':
                defaultService = systematic.businessService;
                break;
            case 'mf':
                defaultService = systematic.mfService;
                break;
        }
    }
    return defaultService;
};

/** WebUniversal属性 */
export interface WebUniversalProps extends Omit<BaseWebUniversalProps, 'defaultService'> {
    /** 后台服务数据 */
    serviceId?: ServiceIdType;
};

/**
 * 组件 WebUniversal
 */
const WebUniversal = forwardRef<any, WebUniversalProps>((props, ref) => {
    const refLocal = useRef<any>(undefined);
    /** 合并外部 ref 和内部 refLocal */
    const mergedRef = useCallback(
        (node: any) => {
            refLocal.current = node;
            if (typeof ref === 'function') {
                ref(node);
            } else if (ref) {
                ref.current = node;
            }
        },
        [ref],
    );

    const { serviceId } = props;
    const currentProps: BaseWebUniversalProps = {
        ...props,
        defaultService: getService(serviceId),
        displayOptions: {
            ...props?.displayOptions,
            loggerProps: {
                ...props?.displayOptions?.loggerProps,
                loggerServiceUrl: getService('bm')
            }
        }
    }
    return <BaseWebUniversal ref={mergedRef} {...currentProps} />;
});

export default WebUniversal;